/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

function isClientErrorStatus(status) {
  return status >= 400 && status < 500;
}

// Returns the raw CSV body — the dialog owns the user-facing success/error branches (saveFile,
// Toast by status/subcode). Expected 4xx is passed through rejectWithValue so unwrap() keeps
// status/msg/subcode; unexpected failures are logged then rejected the same way.
export const exportProductsCsv = createAsyncThunk(
  'products/exportCsv',
  async (payload, { extra: { sdk, Logger }, rejectWithValue }) => {
    try {
      const { data } = await sdk.products.exportCSV(payload);

      Logger.log('User', 'ProductsCsvExported', {
        scope: 'selection',
        records_count: payload.recordIds?.length || 0,
        fields_count: payload.fields?.length || 0,
        all_fields: !payload.fields?.length,
      });

      return data;
    } catch (error) {
      const status = error.response?.status;
      const data = error.response?.data || {};

      if (!isClientErrorStatus(status)) {
        Logger.error(new Error('Error exporting products CSV'), { error }, [
          'ExportProductsCsvFailed',
          { errorMessage: error?.message || 'NoMessage' },
        ]);
      }

      return rejectWithValue({
        status,
        msg: data.msg,
        subcode: data.subcode,
      });
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(exportProductsCsv.pending, (state) => {
      state.ui.exportingCsv = true;
    })
    .addCase(exportProductsCsv.fulfilled, (state) => {
      state.ui.exportingCsv = false;
    })
    .addCase(exportProductsCsv.rejected, (state) => {
      state.ui.exportingCsv = false;
    });
};
